import React from 'react';
import PropTypes from 'prop-types';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import Container from 'common/Container';
import { useTheme } from '@material-ui/core/styles';
import { readableHeading } from '../readablePalette';

const LEGALMENTE_LOGO = '/images/logos/LOGO%20legalmente.png';

const Hero = ({ themeMode = 'light' }) => {
  const theme = useTheme();
  const h = readableHeading(theme);

  return (
    <Box>
      <Box marginBottom={3}>
        <Container
          sx={{
            backgroundImage:
              themeMode === 'dark'
                ? 'url(/images/logos/logo_white.PNG)'
                : 'url(/images/logos/logo_tnonetwork_black.png)',
            backgroundRepeat: 'no-repeat',
            backgroundPosition: 'center',
            backgroundSize: 'contain',
            height: '16vh',
          }}
        />
        <Typography
          sx={{ textTransform: 'uppercase', fontWeight: 600, letterSpacing: '0.12em' }}
          variant="overline"
          color="textSecondary"
          align="center"
          display="block"
          gutterBottom
        >
          Propuesta institucional
        </Typography>
        <Box
          component={Typography}
          fontWeight={700}
          variant="h3"
          gutterBottom
          align="center"
          sx={{ fontFamily: 'Georgia, "Times New Roman", serif', color: h, px: { xs: 1, sm: 0 } }}
        >
          Ilustre Colegio de Abogados de Caracas (Distrito Capital) × Legalmente en Familia
        </Box>
        <Typography
          variant="h5"
          component="p"
          align="center"
          sx={{
            fontWeight: 600,
            color: theme.palette.secondary.main,
            fontStyle: 'italic',
            fontFamily: 'Georgia, "Times New Roman", serif',
            mb: 2,
          }}
        >
          Ética, formación y respaldo gremial
        </Typography>
        <Box display="flex" justifyContent="center" mb={3}>
          <Box
            component="img"
            src={LEGALMENTE_LOGO}
            alt="Legalmente en Familia — programa ancla"
            sx={{ width: 140, maxWidth: '42%', height: 'auto', objectFit: 'contain' }}
          />
        </Box>
        <Typography variant="body1" color="textSecondary" align="center" sx={{ maxWidth: 820, mx: 'auto', lineHeight: 1.75 }}>
          El objetivo no es solo anunciar: es <strong>posicionar al Colegio</strong> como ente rector que vela por la ética y
          la actualización profesional de sus agremiados, usando el programa de la{' '}
          <strong>Dra. Leila Davogustto</strong> —condecorada por el propio Colegio— como puente natural hacia la familia y
          la ciudadanía.
        </Typography>
      </Box>
    </Box>
  );
};

Hero.propTypes = {
  themeMode: PropTypes.string,
};

export default Hero;
